var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 33,
    viewBox: "0 0 22 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1.75C5.47917 1.75 1 6.17738 1 11.6303C1 17.9046 7.66667 27.8477 10.1146 31.282C10.2162 31.427 10.3494 31.5449 10.5032 31.6263C10.6571 31.7076 10.8273 31.75 11 31.75C11.1727 31.75 11.3429 31.7076 11.4968 31.6263C11.6506 31.5449 11.7838 31.427 11.8854 31.282C14.3333 27.8491 21 17.9097 21 11.6303C21 6.17738 16.5208 1.75 11 1.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 16.75C13.2091 16.75 15 14.9591 15 12.75C15 10.5409 13.2091 8.75 11 8.75C8.79086 8.75 7 10.5409 7 12.75C7 14.9591 8.79086 16.75 11 16.75Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.f7be71f94240230a5950337b03b2efc2.svg";
export { ForwardRef as ReactComponent };